import React from 'react';
import {OvrecommendDetails_ovrecommendDetails_recommends} from '../../schema-types/OvrecommendDetails';

export interface RecommendsTableProps {
  recommends: OvrecommendDetails_ovrecommendDetails_recommends[];
}

const RecommendsTable: React.FC<RecommendsTableProps> = ({recommends}) => {
  const tableStyle = {
    backgroundColor: 'white',
    borderCollapse: 'collapse' as const,
  };

  const cellStyle = {
    border: '1px solid lightgrey',
    padding: '8px',
    textAlign: 'left' as const,
  };

  const headerCellStyle = {
    ...cellStyle,
    textAlign: 'center' as const,
  };

  return (
    <table style={tableStyle} data-testid="recommendsTable">
      <thead>
        <tr>
          <th style={headerCellStyle} colSpan={2}>
            RECOMMENDS
          </th>
        </tr>
        <tr>
          <th style={cellStyle}>ADVICE</th>
          <th style={cellStyle}>AMOUNT</th>
        </tr>
      </thead>
      <tbody>
        {recommends.map((recommendation) => (
          <tr key={recommendation.advice + recommendation.totalContributionPremium}>
            <td style={cellStyle}>{recommendation.advice}</td>
            <td style={cellStyle}>{recommendation.totalContributionPremium}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default RecommendsTable;
